import api from 'api'
import { ILearningPathCard } from 'models/learningPathCard.model'
import { IPrerequisites } from 'models/prerequisites.model'

const learningPaths = ({
  page = 1,
  perPage = 8,
  search = '',
}): Promise<ILearningPathCard[]> => {
  return api
    .get('/learning_paths', {
      params: {
        page,
        per_page: perPage,
        search,
      },
    })
    .then(({ data }) => {
      return data.data.map(({ attributes }) => attributes)
    })
}

export const getPrerequisites = async ({
  courseId,
}): Promise<{ data: IPrerequisites[]; canContinueCourse: boolean }> => {
  const { data } = await api.get(
    `/learning_paths/prerequisites_by_course/${courseId}`
  )
  return data
}

export default learningPaths
